<app-statistics grapType="summary"></app-statistics>